/* -----------------------------------------------------------------------------
 * Tako Radio Button Group
 * -------------------------------------------------------------------------- */
import { getLogger } from './utils/logger-context';
import { resolveComponentScope } from './utils/resolveComponentScope';

const COMPONENT_NAME = 'RadioButtonGroup';

export const init = (unresolvedScope) => {
    const logger = getLogger();
    const scope = resolveComponentScope(unresolvedScope);
    const defaultLoggerArgs = {
        componentName: COMPONENT_NAME,
        scope,
    };
    logger.debug(`Initialising ${COMPONENT_NAME} component.`, { scope });

    const allTakoRadioButtonGroups = scope.querySelectorAll(
        '.tako-radio-button-group',
    );

    allTakoRadioButtonGroups.forEach(function (radioButtonGroup) {
        try {
            const instanceLoggerArgs = {
                ...defaultLoggerArgs,
                element: radioButtonGroup,
            };
            const labels = radioButtonGroup.querySelectorAll('label');
            const radioButtons = radioButtonGroup.querySelectorAll(
                'input[type="radio"]',
            );
            const direction = radioButtonGroup.dataset.direction || 'column';

            if (direction === 'row') {
                radioButtonGroup.classList.add(
                    'tako-radio-button-group--horizontal',
                );
            }

            labels.forEach((label) => {
                label.classList.add('tako-radio-button-group__wrapper-label');
            });

            // Currently if a radio button is not wrapped in a label then it does not work
            if (labels.length < radioButtons.length) {
                logger.warn(
                    'Currently all tako radio buttons must be wrapped in a label element',
                    instanceLoggerArgs,
                );
            }

            radioButtons.forEach((radioButton) => {
                radioButton.classList.add('tako-radio-button-group__input');

                const customTakoRadio = document.createElement('span');
                customTakoRadio.classList.add(
                    'tako-radio-button-group__custom-radio',
                );
                radioButton.parentNode.insertBefore(
                    customTakoRadio,
                    radioButton.nextSibling,
                );
            });
        } catch (error) {
            logger.error(error, {
                ...defaultLoggerArgs,
                element: radioButtonGroup,
            });
        }
    });
};
